<template>
  <div class="canteen-management">
    <div class="canteen-management-container">
      <div class="top-container">
        <div class="title">食堂管理</div>
        <div class="search">
          <el-button
            v-if="
              OPERATION_LIST.findIndex(
                (item) => item === OPERATIONS_BTNS.roleAddCanteen
              ) !== -1
            "
            type="text"
            class="btn-blue add"
            icon="el-icon-plus"
            @click="add"
            >创建</el-button
          >
        </div>
      </div>
      <div class="table" v-if="tableData.length > 0">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column
            v-for="(item, index) in tableTitleList"
            :key="index"
            :prop="item.prop"
            :label="item.lable"
            :width="item.width"
            :show-overflow-tooltip="item.showOverflowTooltip"
          />
          <el-table-column label="服务范围">
            <template slot-scope="scope">
              <el-tooltip
                v-if="scope.row.controlLimit != '—'"
                effect="dark"
                placement="top">
                <div slot="content">
                  <div v-for="(item,index) in scope.row.managementScope" :key="index">
                    {{ item.deptName }}
                    <br />
                  </div>
                </div>
                <p v-if="
              OPERATION_LIST.findIndex(
                (item) => item === OPERATIONS_BTNS.roleUpdateCanteen
              ) == -1
            ">{{ scope.row.controlLimit }}</p>
                <p v-else class="controlLimit" @click="setUp(scope.row)">{{ scope.row.controlLimit }}</p>
              </el-tooltip>
              <div v-else>
                <p v-if="
              OPERATION_LIST.findIndex(
                (item) => item === OPERATIONS_BTNS.roleUpdateCanteen
              ) == -1
            ">{{ scope.row.controlLimit }}</p>
                <p v-else class="controlLimit" @click="setUp(scope.row)">{{ scope.row.controlLimit }}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="指战员委员会">
            <template slot-scope="scope">
              <el-tooltip
                v-if="scope.row.memberStr"
                effect="dark"
                placement="top">
                <div slot="content">
                  <div>
                    {{ scope.row.directorList }}
                    <br />
                    {{ scope.row.deputyDirectorList }}
                    <br />
                    {{ scope.row.memberList }}
                    <br />
                  </div>
                </div>
                <p>{{ scope.row.memberStr }}</p>
              </el-tooltip>
              <div v-else>—</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <i 
            v-if="
              OPERATION_LIST.findIndex(
                (item) => item === OPERATIONS_BTNS.roleUpdateCanteen
              ) !== -1
            " class="el-icon-edit mod" @click="mod(scope.row)"></i>
              <!-- <i 
            v-if="
              OPERATION_LIST.findIndex(
                (item) => item === OPERATIONS_BTNS.roleDelCanteen
              ) !== -1
            " class="el-icon-delete" @click="remove(scope.row)"></i> -->
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-tpl-container">
          <pagination-tpl
            :total="totalNum"
            :currentPage="currentPage"
            @queryChange="onQueryChange"
          ></pagination-tpl>
        </div>
      </div>
      <div class="nothing" v-if="tableData.length == 0">
        <div>
          <div>
            <img src="../../../../assets/nothing.png">
          </div>
          <p>暂无数据</p>
        </div>
      </div>

      <el-drawer
        :visible.sync="drawer"
        :size="400"
        :modal="false"
        :with-header="false"
        :wrapperClosable="false"
      >
        <div class="drawer-title">
          <i class="el-icon-close" @click="closeDrawer"></i>
          <div>
            <el-button type="text" class="btn-gray" @click="closeDrawer"
              >取消</el-button
            >
            <el-button
              type="text"
              class="btn-blue"
              @click="submitForm('ruleForm')"
              >保存</el-button
            >
          </div>
        </div>
        <div class="sub-title">{{ isMod ? '编辑': '创建'}}</div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          class="demo-ruleForm"
        >
          <el-form-item label="食堂名称" prop="canteenName">
            <el-input class="gray white" v-model="ruleForm.canteenName" placeholder="请输入"></el-input>
          </el-form-item>
          <!-- <el-form-item label="管理员" prop="admin">
            <select-tree
              key="005"
              v-if="departmentObj.id"
              :disabled="isMod"
              :departmentList="departmentHeadList"
              :departmentId="departmentObj"
              @selectTreeNodeList="selectDepartmentHeadTreeNodeList"
            />
            <select-tree
              v-else
              key="006"
              :disabled="isMod"
              :departmentList="departmentHeadList"
              :departmentId="departmentObj"
              @selectTreeNodeList="selectDepartmentHeadTreeNodeList"
            />
          </el-form-item> -->
          <el-form-item label="采购人" prop="purchaser">
            <select-multiple-tree
              :selectObj="purchaserObj"
              :departmentList="departmentHeadList"
              @selectTreeNodeList="selectDepartmentList"
              @getSelectChange="purchaserSelectChange"
            />
          </el-form-item>
          <el-form-item label="验收人" prop="acceptor">
            <select-multiple-tree
              :selectObj="acceptorObj"
              :departmentList="departmentHeadList"
              @selectTreeNodeList="selectAcceptor"
              @getSelectChange="acceptorSelectChange"
            />
          </el-form-item>
          <el-form-item label="服务范围" prop="controlLimit">
            <div class="services" :class="isMod?'disabled-controlLimit':''" @click="openControlLimit">
              <p v-if="ruleForm.controlLimit">{{ ruleForm.controlLimit }}</p>
              <p class="placeholder" v-else>请选择</p>
            </div>
          </el-form-item>
          <el-form-item label="主任" prop="directorUserNameList">
            <div class="services" @click="openSelectMenber(1)">
              <p v-if="ruleForm.directorUserNameList">{{ ruleForm.directorUserNameList }}</p>
              <p class="placeholder" v-else>请选择</p>
            </div>
          </el-form-item>
          <el-form-item label="副主任" prop="deputyDirectorUserNameList">
            <div class="services" @click="openSelectMenber(2)">
              <p v-if="ruleForm.deputyDirectorUserNameList">{{ ruleForm.deputyDirectorUserNameList }}</p>
              <p class="placeholder" v-else>请选择</p>
            </div>
          </el-form-item>
          <el-form-item label="成员" prop="memberUserNameList">
            <div class="services" @click="openSelectMenber(3)">
              <p v-if="ruleForm.memberUserNameList">{{ ruleForm.memberUserNameList }}</p>
              <p class="placeholder" v-else>请选择</p>
            </div>
          </el-form-item>
        </el-form>
      </el-drawer>
    </div>

    <!-- 选择服务范围 -->
    <all-department-dialog
      :departmentDialog="departmentDialog"
      :moduleType="'food'"
      :departmentDialogTitle="departmentDialogTitle"
      @allOPenOrCloseDepartmentDialog="allOPenOrCloseDepartmentDialog"
      @allSubmitSelectData="allSubmitSelectData"
    ></all-department-dialog>

    <!-- 选择人员 -->
    <all-department-people-dialog
      :refStr="'treeSelectPeople'"
      :departmentDialog="selectMenberDialog"
      :departmentDialogTitle="selectMenberDialogTitle"
      @allOPenOrCloseDepartmentDialog="allOPenOrCloseSelectMenberDialog"
      @allSubmitSelectData="allSubmitSelectMenber"
    ></all-department-people-dialog>
  </div>
</template>

<script>
import { config } from '@/common/js/config.js'
import PaginationTpl from "@/components/PaginationTpl.vue";
import AllDepartmentDialog from "@/components/all-department-dialog.vue";
import AllDepartmentPeopleDialog from "@/components/all-department-people-dialog.vue";
import SelectTree from "@/components/select-tree";
import Department from "@/models/department.js";
import { mapChild, mapId2 } from "@/common/js/utils.js";
import { getTeamId } from "common/js/storage";
import { operationMixins } from '@/common/mixins/operation/operation.js'
import SelectMultipleTree from "@/components/select-multiple-tree.vue";
import Canteen from "@/models/canteen.js";
export default {
  mixins: [operationMixins],

  components: {
    PaginationTpl,
    AllDepartmentDialog,
    SelectTree,
    SelectMultipleTree,
    AllDepartmentPeopleDialog
  },

  data() {
    return {
      canteenId: 1,
      totalNum: 0,
      currentPage: 1,
      tableData: [],
      tableTitleList: [
        { prop: "canteenName", lable: "食堂名称", width: "", showOverflowTooltip:false },
        { prop: "admin", lable: "管理员", width: "", showOverflowTooltip:false },
        { prop: "purchaser", lable: "采购人", width: "", showOverflowTooltip:true },
        { prop: "acceptor", lable: "验收人", width: "", showOverflowTooltip:true },
      ],     
       /* 
        以下是选择部门字段
       */
      departmentDialog: false,
      departmentDialogTitle: '编辑管理范围',
      /* 是否开启抽屉 */
      drawer: false,
      departmentHeadList: [],
      departmentObj: {
        id: 0,
        name: ''
      },
      ruleForm: {
        canteenName: '',
        admin: '',
        purchaser: '',
        acceptor: '',
        controlLimit: '',
        directorUserNameList: '',
        deputyDirectorUserNameList: '',
        memberUserNameList: '',
      },
      rules: {
        canteenName: [{ required: true, message: "请输入食堂名称", trigger: "blur" }],
        controlLimit: [{ required: true, message: "请选择服务范围", trigger: "change" }],
      },
      /* 采购人id集合 */
      purchaserIdList: [],
      /* 验收人id集合 */
      acceptorIdList: [],
      /* 是否编辑; 1.是; 0.否*/
      isMod: '',
      /* 服务范围id集合 */
      deptIdList: [],
      /* 是否是编辑服务范围; 1.是; 0.否 */
      isModServices: '',
      purchaserObj: {
        arr: [],
        labelArr: []
      },
      acceptorObj: {
        arr: [],
        labelArr: []
      },

      /* 主任id集合 */
      directorUserIdList: [],
      /* 副主任id集合 */
      deputyDirectorUserIdList: [],
      /* 成员id集合 */
      memberUserIdList: [],
      directorAllList: [],
      deputyDirectorAllList: [],
      memberAllList: [],
      /* 1:主任; 2: 副主任; 3: 成员 */
      isMenberType: 1,
      selectMenberDialog: false,
      selectMenberDialogTitle: '选择成员'
    }
  },

  created() {
    config()
    this.initTableList()
    this.initDepartmentHeadList()
  },

  methods: {
    initTableList() {
      let currentPage = this.currentPage;
      Canteen.getCanteenList(currentPage).then(
        (res) => {
          if (res.success) {
            this.totalNum = res.result.totalNum;
            let arr = [];
            res.result.items.map((i) => {
              let obj = {};
              obj.id = i.id;
              obj.canteenName = i.name ? i.name : "—";
              obj.admin = i.canteenAdmin ? i.canteenAdmin.userName : "—";
              obj.buyerList = i.buyerList;
              obj.acceptorList = i.acceptorList;
              obj.managementScope = i.deptList;
              let controlLimit = [];
              let purchaserList = []
              let acceptorList = []
              let directorList = []
              let deputyDirectorList = []
              let memberList = []
              if (i.directorList) {
                i.directorList.map((v) => {
                  directorList.push(v.userName);
                });
              }
              if (directorList.length > 0) {
                obj.directorList = `主任：${directorList.join(";")}；`;
              } else {
                obj.directorList = "";
              }
              if (i.deputyDirectorList) {
                i.deputyDirectorList.map((v) => {
                  deputyDirectorList.push(v.userName);
                });
              }
              if (deputyDirectorList.length > 0) {
                obj.deputyDirectorList = `副主任：${deputyDirectorList.join(";")}；`;
              } else {
                obj.deputyDirectorList = "";
              }
              if (i.memberList) {
                i.memberList.map((v) => {
                  memberList.push(v.userName);
                });
              }
              if (memberList.length > 0) {
                obj.memberList = `成员：${memberList.join(";")}；`;
              } else {
                obj.memberList = "";
              }
              obj.memberStr = `${obj.directorList}${obj.deputyDirectorList}${obj.memberList}`
              if (i.deptList) {
                i.deptList.map((v) => {
                  controlLimit.push(v.deptName);
                });
              }
              if (controlLimit.length > 0) {
                obj.controlLimit = controlLimit.join(";");
              } else {
                obj.controlLimit = "—";
              }
              if (i.buyerList.length > 0) {
                i.buyerList.map((v) => {
                  purchaserList.push(v.userName);
                });
              }
              if (purchaserList.length > 0) {
                obj.purchaser = purchaserList.join(",");
              } else {
                obj.purchaser = "—";
              }
              if (i.acceptorList.length > 0) {
                i.acceptorList.map((v) => {
                  acceptorList.push(v.userName);
                });
              }
              if (acceptorList.length > 0) {
                obj.acceptor = acceptorList.join(",");
              } else {
                obj.acceptor = "—";
              }

              arr.push(obj);
            });
            this.tableData = arr;
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        }
      );
    },

    /* 获取管理员数据 */
    initDepartmentHeadList() {
      let searchDepartment = ''
      let id = getTeamId()
      Department.getDepartmentPeopleList(id, searchDepartment).then(res => {
        if (res.success) {
          let arr = mapChild(res.result);
          this.departmentHeadList = mapId2(arr);
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    /* 详情 */
    initDetails() {
      let id = this.canteenId;
      Canteen.getDetails(id).then(
        (res) => {
          if (res.success) {
            let { acceptorList, buyerList, canteenAdmin, deptList, id, name,
            directorList, deputyDirectorList, memberList} = res.result
            this.canteenId = id
            this.ruleForm.canteenName = name
            this.departmentObj.id = canteenAdmin ? canteenAdmin.userId: 0
            this.departmentObj.name = canteenAdmin? canteenAdmin.userName: 0
            this.ruleForm.admin = canteenAdmin? canteenAdmin.userId: 0
            let purchaserIdList = []
            let buyerArr = []
            let buyerLabelArr = []
            buyerList.map(i => {
              let obj = {}
              obj.id2 = i.userId
              obj.departmentName = i.userName
              obj.zzdCode = i.zzdCode
              buyerArr.push(obj)
              buyerLabelArr.push(i.userName)
              purchaserIdList.push(i.userId)
            })
            this.purchaserObj.arr = buyerArr
            this.purchaserObj.labelArr = buyerLabelArr
            this.purchaserIdList = purchaserIdList

            let acceptorIdList = []
            let acceptorArr = []
            let acceptorLabelArr = []
            acceptorList.map(i => {
              let obj = {}
              obj.id2 = i.userId
              obj.departmentName = i.userName
              obj.zzdCode = i.zzdCode
              acceptorArr.push(obj)
              acceptorLabelArr.push(i.userName)
              acceptorIdList.push(i.userId)
            })
            this.acceptorObj.arr = acceptorArr
            this.acceptorObj.labelArr = acceptorLabelArr
            this.acceptorIdList = acceptorIdList

            let deptIdList = []
            let arr = []
            deptList.map(i => {
              deptIdList.push(i.deptId)
              arr.push(i.deptName)
            })
            this.deptIdList = deptIdList
            this.ruleForm.controlLimit = arr.join(';')
            
            let directorUserIdList = [];
            let directorUserNameList = [];
            let directorAllList = [];
            directorList.map((i) => {
              let obj = {}
              obj.id = i.userId
              obj.name = i.userName
              obj.zzdCode = i.zzdCode
              directorAllList.push(obj)
              directorUserIdList.push(i.userId);
              directorUserNameList.push(i.userName);
            });
            this.directorAllList = directorAllList
            this.directorUserIdList = directorUserIdList
            this.ruleForm.directorUserNameList = directorUserNameList.join(';')
            
            let deputyDirectorUserIdList = [];
            let deputyDirectorUserNameList = [];
            let deputyDirectorAllList = [];
            deputyDirectorList.map((i) => {
              let obj = {}
              obj.id = i.userId
              obj.name = i.userName
              obj.zzdCode = i.zzdCode
              deputyDirectorAllList.push(obj)
              deputyDirectorUserIdList.push(i.userId);
              deputyDirectorUserNameList.push(i.userName);
            });
            this.deputyDirectorAllList = deputyDirectorAllList
            this.deputyDirectorUserIdList = deputyDirectorUserIdList
            this.ruleForm.deputyDirectorUserNameList = deputyDirectorUserNameList.join(';')

            let memberUserIdList = [];
            let memberUserNameList = [];
            let memberAllList = [];
            memberList.map((i) => {
              let obj = {}
              obj.id = i.userId
              obj.name = i.userName
              obj.zzdCode = i.zzdCode
              memberAllList.push(obj)
              memberUserIdList.push(i.userId);
              memberUserNameList.push(i.userName);
            });
            this.memberAllList = memberAllList
            this.memberUserIdList = memberUserIdList
            this.ruleForm.memberUserNameList = memberUserNameList.join(';')
            this.$bus.emit('upload', 2)
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        }
      );
    },

    /* 翻页 */
    onQueryChange(data) {
      this.currentPage = data.currentPage;
      this.initTableList();
    },

    add() {
      this.isModServices = 0
      this.isMod = 0
      this.drawer = true
    },

    mod(v) {
      this.canteenId = v.id
      this.isModServices = 0
      this.isMod = 1
      this.initDetails()
      this.drawer = true
    },

    remove(v) {
      this.$confirm("食堂删除后不可恢复，是否继续？", "确认删除食堂", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        confirmButtonClass: 'btn-red',
        cancelButtonClass: 'btn-gray'
      }).then(() => {
        let data = {
          id: v.id
        }
        Canteen.postDelCanteen(data).then(res => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '删除成功'
            });
            this.initTableList()
          } else {
            this.$message({
              type: 'error',
              message: res.message
            });
          }
        })
      });
    },

    setUp(row) {
      this.isModServices = 1
      this.canteenId = row.id
      this.departmentDialog = true;
      let arr = []
      row.managementScope.map(i => {
        let obj = {}
        obj.id = i.deptId
        obj.name = i.deptName
        arr.push(obj)
      })
      this.selectAllDepartmentList = arr
      this.$bus.emit('initSelectAllDepartmentList', arr)
    },

    /* 选中的管理员 */
    selectDepartmentHeadTreeNodeList(v) {
      this.departmentObj.id = v.id
      this.ruleForm.admin = v.id2
    },

    /* 关闭部门弹窗 */
    allOPenOrCloseDepartmentDialog(data) {
      this.departmentDialog = data;
    },

    /* 确定部门弹窗 */
    allSubmitSelectData(v) {
      let deptIdList = []
      let controlLimit = []
      let arr = []
      v.map(i => {
        let obj = {}
        obj.id = i.id
        obj.name = i.departmentName
        arr.push(obj)
        deptIdList.push(i.id)
        controlLimit.push(i.departmentName)
      })
      this.deptIdList = deptIdList

      if (this.isModServices) {
        let id = this.canteenId
        let data = {
          id,
          deptIdList
        }
        Canteen.postModCanteenRange(data).then((res) => {
          if (res.success) {
            this.$message({
              type: "success",
              message: "修改成功",
            });
            this.initTableList();
            this.allOPenOrCloseDepartmentDialog(false);
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        });
      } else {
        this.ruleForm.controlLimit = controlLimit.join(';')
        this.selectAllDepartmentList = arr
        this.allOPenOrCloseDepartmentDialog(false);
      }
      
    },

    closeDrawer() {
      this.ruleForm.canteenName = '',
      this.ruleForm.admin = '',
      this.ruleForm.purchaser = '',
      this.ruleForm.acceptor = '',
      this.ruleForm.controlLimit = '',
      this.departmentObj = {
        id: 0,
        name: ''
      },
      this.selectAllDepartmentList = [],
      this.purchaserIdList = [],
      this.acceptorIdList = [],
      this.purchaserObj = {
        arr: [],
        labelArr: []
      },
      this.acceptorObj = {
        arr: [],
        labelArr: []
      }
      this.$nextTick(() => {
        this.$bus.emit('upload', 1)
      })
      this.drawer = false
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let name = this.ruleForm.canteenName
          // let canteenAdminId = this.ruleForm.admin
          let buyerIdList = this.purchaserIdList
          let acceptorIdList = this.acceptorIdList
          let deptIdList = this.deptIdList
          let directorUserIdList = this.directorUserIdList
          let deputyDirectorUserIdList = this.deputyDirectorUserIdList
          let memberUserIdList = this.memberUserIdList
          let data = {
            name,
            // canteenAdminId,
            buyerIdList,
            acceptorIdList,
            deptIdList,
            directorUserIdList,
            deputyDirectorUserIdList,
            memberUserIdList
          }
          if (!this.isMod) {
            Canteen.postAddCanteen(data).then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '新增成功'
                })
                this.initTableList();
                this.closeDrawer()
              } else {
                this.$message({
                  type: 'error',
                  message: res.message
                });
              }
            })
          } else {
            data.id = this.canteenId
            Canteen.postModCanteen(data).then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '编辑成功'
                })
                this.initTableList();
                this.closeDrawer()
              } else {
                this.$message({
                  type: 'error',
                  message: res.message
                });
              }
            })
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    /* 采购人选中数据 */
    selectDepartmentList(v) {
      let arr = []
      v.map(i => {
        arr.push(i.id2)
      })
      this.purchaserIdList = arr
    },

    purchaserSelectChange(v) {
      let arr = []
      v.map(i => {
        arr.push(i.id2)
      })
      this.purchaserIdList = arr
    },

    /* 验收人选中数据 */
    selectAcceptor(v) {
      let arr = []
      v.map(i => {
        arr.push(i.id2)
      })
      this.acceptorIdList = arr
    },

    acceptorSelectChange(v) {
      let arr = []
      v.map(i => {
        arr.push(i.id2)
      })
      this.acceptorIdList = arr
    },

    /* 开启选择服务范围 */
    openControlLimit() {
      if (!this.isMod) {
        this.departmentDialog = true;
        this.$bus.emit('initSelectAllDepartmentList', this.selectAllDepartmentList)
      }
    },

    allOPenOrCloseSelectMenberDialog(data) {
      this.selectMenberDialog = data;
    },

    allSubmitSelectMenber(v) {
      let userIds = [];
      let userNameList = [];
      let arr = []
      v.map((i) => {
        let obj = {}
        obj.id = i.id2
        obj.name = i.departmentName
        arr.push(obj)
        userIds.push(i.id2);
        userNameList.push(i.departmentName);
      });
      if (this.isMenberType == 1) {
        this.directorUserIdList = userIds
        this.directorAllList = arr
        this.ruleForm.directorUserNameList = userNameList.join(';')
      }
      if (this.isMenberType == 2) {
        this.deputyDirectorUserIdList = userIds
        this.deputyDirectorAllList = arr
        this.ruleForm.deputyDirectorUserNameList = userNameList.join(';')
      }
      if (this.isMenberType == 3) {
        this.memberUserIdList = userIds
        this.memberAllList = arr
        this.ruleForm.memberUserNameList = userNameList.join(';')
      }
      this.selectMenberDialog = false;
    },

    openSelectMenber(type) {
      this.isMenberType = type
      if (type == 1) this.$bus.emit('initSelectAllList', this.directorAllList)
      if (type == 2) this.$bus.emit('initSelectAllList', this.deputyDirectorAllList)
      if (type == 3) this.$bus.emit('initSelectAllList', this.memberAllList)
      this.selectMenberDialog = true;
    }

  }
}
</script>

<style lang='scss' scoped>
.canteen-management {
  flex: 1;
  padding: 20px;
  box-sizing: border-box;
  background: $bg-white;
  .canteen-management-container {
    height: 100%;
    position: relative;
  }
  .top-container {
    @include flex-between;
    margin-bottom: 20px;
    .title {
      padding-left: 10px;
      font-size: $fs-medium-s;
      color: $color-BlackGrey;
      border-left: 4px solid $color-DeepReddishBlue;
    }
    .search {
      display: flex;
      .add {
        margin-left: 12px;
        padding: 0;
      }
    }
  }
  .controlLimit {
    color: $color-DeepReddishBlue;
    cursor: pointer;
  }
  .mod {
    margin-right: 20px;
  }
  .mod,
  .el-icon-delete {
    cursor: pointer;
  }
  .sub-title {
    text-align: left;
    font-size: $fs-medium-s;
    font-weight: 400;
    margin-bottom: 25px;
    color: $color-Step;
  }
  .nothing {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    img {
      width: 157px;
      height: 157px;
    }
    p {
      font-size: $fs-small-l;
      font-weight: 400;
      color: $color-LightGrey;
      margin-top: 24px;
    }
  }
  .services {
    min-height: 32px;
    line-height: 32px;
    text-align: left;
    padding: 0px 15px;
    border-radius: 2px;
    margin-top: 28px;
    cursor: pointer;
    border: 1px solid $bg-ShallowLightSnow;
    .placeholder {
      color: $color-UploadTips;
    }
  }
  .disabled-controlLimit {
    cursor: no-drop;
    background: $bg-Disabled;
    color: $color-Disabled;
  }
}
</style>
<style lang='scss'>
.canteen-management {
  .el-form-item.is-required:not(.is-no-asterisk)
    .el-form-item__label-wrap
    > .el-form-item__label:before,
  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
    display: none;
  }
  .el-form-item.is-required:not(.is-no-asterisk)
    .el-form-item__label-wrap
    > .el-form-item__label:before,
  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label::after {
    content: "*";
    color: $bg-Required;
    margin-left: 4px;
  }
  .el-form-item__label {
    line-height: 22px;
  }
  .el-drawer__wrapper {
    top: 119px !important;
    right: 20px;
  }
}
</style>